import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-gray-600 text-sm py-2 border-b border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_change_log_section = _resolveComponent("change-log-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.formattedDate), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_change_log_section, {
        title: "新功能",
        items: _ctx.changeLog.feature
      }, null, 8, ["items"]),
      _createVNode(_component_change_log_section, {
        title: "BUG 修复",
        items: _ctx.changeLog.bugFix
      }, null, 8, ["items"]),
      _createVNode(_component_change_log_section, {
        title: "功能优化",
        items: _ctx.changeLog.optimization
      }, null, 8, ["items"])
    ])
  ]))
}